import * as types from './mutations-types'
import myRecordApi from '../../../../../api/wx-member/go-out-management/my-record/my-record'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'

export default {
  searchInfoByData: ({ commit }, data) => {
    myRecordApi.searchInfoByData(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'applicationType',
            fieldPropName: 'applicationTypeName',
            fieldFormatParam: DictionaryConstants.APPLICATION_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
          let list = res
          commit(types.MY_RECORD_DATA, list)
        })
      })
  },
  getCancelRecord: ({ commit }, data) => {
    myRecordApi.getCancelRecord(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
          result = res
          commit(types.CANCEL_RECORD_LIST, result)
        })
      })
  },
  updateCouponRecord: ({ commit }, data) => {
    commit(types.UPDATE_COUPON_INFO_RECORD, data)
  },
  updateCouponFalseRecord: ({ commit }, data) => {
    commit(types.UPDATE_COUPON_INFO_FALSE_RECORD, data)
  },
  getCouponInfoById: ({ commit }, id) => {
    myRecordApi.getCouponInfoById(id)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'applicationType',
            fieldPropName: 'applicationTypeName',
            fieldFormatParam: DictionaryConstants.APPLICATION_TYPE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponDepartment',
            fieldPropName: 'couponDepartmentName',
            fieldFormatParam: DictionaryConstants.DEPARTMENT
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponStatus',
            fieldPropName: 'couponStatusName',
            fieldFormatParam: DictionaryConstants.COUPON_USE_STATUS
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'expiresType',
            fieldPropName: 'expiresTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_EXPIRES_TYPE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DATE,
            fieldPropCode: 'couponCreateTime',
            fieldPropName: 'couponCreateTime',
            fieldFormatParam: 'YYYY/MM/DD'
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result, params).then(res => {
          result = res
          commit(types.GET_COUPON_DETAIL, result)
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/my-record/store/actions.js